import { useMemo } from 'react';

import { demoWoopWorkloadFilters } from '@cast/fixtures';
import { WorkloadFiltersResponse } from '@cast/types';

import { useWorkloadFiltersQuery } from 'hooks/queries/workload-optimization';
import { useDataOrFixture } from 'hooks/useDataOrFixture';

import { useIsWoopDemoMode } from './useIsWoopDemoMode';

import { useCluster } from '@cast/shared-cluster-context-data-access';

export const useWoopWorkloadFilters = ({
  enabled = true,
  optimizedOnly = false,
}: { enabled?: boolean; optimizedOnly?: boolean } = {}) => {
  const { cluster } = useCluster();
  const isWoopDemoMode = useIsWoopDemoMode();

  const demoFiltersFixture = useMemo(() => () => demoWoopWorkloadFilters(), []);

  const queryResult = useWorkloadFiltersQuery({
    clusterId: cluster.id,
    enabled: !isWoopDemoMode && enabled,
    optimizedOnly,
  });

  const filtersDataOrFixture = useDataOrFixture<WorkloadFiltersResponse>(
    queryResult.data,
    demoFiltersFixture,
    isWoopDemoMode
  );

  return { ...queryResult, data: filtersDataOrFixture };
};
